import React from 'react';
import { useTranslations } from 'next-intl';
import { classNames } from '@/shared/lib/classnames/classnames';
export interface SliderPaginationProps {
  count: number;
  activeIndex: number;
  onIndexChange?: (idx: number) => void;
  className?: string;
}
export const SliderPagination: React.FC<SliderPaginationProps> = ({
  count,
  activeIndex,
  onIndexChange,
  className = ''
}) => {
  const t = useTranslations();
  if (count <= 1) return null;
  return <div className={classNames('absolute left-1/2 top-16 z-10 flex -translate-x-1/2 items-center gap-2', {}, [className])} data-sentry-component="SliderPagination" data-sentry-source-file="SliderPagination.tsx">
      {Array.from({
      length: count
    }).map((_, idx) => <button key={idx} type="button" className={classNames('size-1 rounded-full transition-colors', {
      'size-2 border-2 border-white bg-white': idx === activeIndex,
      'bg-white/40': idx !== activeIndex
    })} aria-label={`${t('shared.aria.slide', {
      current: idx + 1,
      total: count
    })}`} onClick={() => onIndexChange?.(idx)} />)}
    </div>;
};